import axios from 'axios';
import endpointsService from "@/services/endpointsService";
import {store} from "@/store";

const instance = axios.create({
  baseURL: endpointsService.getMdmEndpoint(),
});

instance.interceptors.request.use((config) => {
  config.baseURL = endpointsService.getMdmEndpoint();
  config.headers.Authorization = `Bearer ${store.jwtToken.value}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default instance;
